// src/login/InstallAppButton.jsx
import { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';

function isInStandalone() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
  const inDisplayMode =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(display-mode: standalone)').matches;
  const iosStandalone = 'standalone' in navigator && navigator.standalone;
  return Boolean(inDisplayMode || iosStandalone);
}

export default function InstallAppButton() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [supported, setSupported] = useState(false);

  useEffect(() => {
    // se já está instalado, não mostra
    if (isInStandalone()) return;

    const handleBeforeInstallPrompt = (e) => {
      // navegadores que suportam PWA install prompt (Chrome/Edge/Android/Desktop)
      e.preventDefault();
      setDeferredPrompt(e);
      setSupported(true);
    };

    const handleAppInstalled = () => {
      // some ao instalar
      setDeferredPrompt(null);
      setSupported(false);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  if (!supported) return null;

  const handleClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    try {
      await deferredPrompt.userChoice; // { outcome, platform }
    } finally {
      // alguns browsers não reenviam o evento; limpa para evitar re-prompt
      setDeferredPrompt(null);
      setSupported(false);
    }
  };

  return (
    <Button
      size="small"
      color="primary"
      variant="outlined"
      onClick={handleClick}
      startIcon={<DownloadForOfflineIcon />}
      aria-label="Instalar app"
    >
      Instalar app
    </Button>
  );
}
